<template>
	<b-card no-body	class="mb-3 shadow-sm" border-variant="light">
        <vue-content-loading :speed="2" :width="500" :height="620">
          <rect x="5" y="0" rx="0" ry="0" width="500" height="320" />
          <rect x="320" y="330" rx="10" ry="10" width="150" height="30" />
          <rect x="20" y="330" rx="10" ry="10" width="150" height="30" />
          <rect x="20" y="400" rx="10" ry="10" width="130" height="30" />
          <rect x="20" y="440" rx="10" ry="10" width="170" height="30" />
          <rect x="20" y="480" rx="10" ry="10" width="90" height="30" />
          <rect x="150" y="530" rx="10" ry="10" width="200" height="40" />
        </vue-content-loading>
	</b-card>
</template>
<script>
  import VueContentLoading from 'vue-content-loading';
  export default {
	name: 'v-car-card-loading',
	components: { 
		VueContentLoading
	}
  }
</script>